module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/atributos-cbcabc1b2712b0ad3fb853a78e3542f9.svg";